(() => {
  const cfg = JSON.parse(document.getElementById("dlt-config").textContent);
  const $ = (s) => document.querySelector(s);
  // ?preview=live pour voir la page du jour J avant l'heure.
  const preview = new URLSearchParams(location.search).get("preview") === "live";
  const dropTime = preview ? Date.now() : new Date(cfg.dropDate).getTime();

  function say(el, text) { el.textContent = text; }

  // ---------- En-tête ----------
  const d = new Date(cfg.dropDate);
  const fmt = (o) => new Intl.DateTimeFormat("fr-FR", { ...o, timeZone: "Europe/Paris" }).format(d);
  $("#metaDate").textContent = `${fmt({ day: "2-digit", month: "2-digit", year: "2-digit" }).replaceAll("/", ".")} · ${fmt({ hour: "2-digit", minute: "2-digit" })}`;

  // ---------- Rouleaux ----------
  const reels = {};
  document.querySelectorAll(".group").forEach((g) => {
    const box = g.querySelector(".digits");
    reels[g.dataset.u] = [0, 1].map(() => {
      const reel = document.createElement("div");
      reel.className = "reel";
      reel.innerHTML = `<div class="strip">${[...Array(10).keys()].map((n) => `<span>${n}</span>`).join("")}</div>`;
      box.appendChild(reel);
      return reel.firstElementChild;
    });
  });
  function setUnit(u, value) {
    String(value).padStart(2, "0").split("").forEach((c, i) => {
      reels[u][i].style.transform = `translateY(${-Number(c) * 10}%)`;
    });
  }

  // ---------- Pièce pixelisée ----------
  const canvas = $("#piece");
  const ctx = canvas.getContext("2d");
  const off = document.createElement("canvas");
  const octx = off.getContext("2d");
  const img = new Image();
  let ready = false;
  let block = 40;
  // Détourage : le fond blanc de la photo devient transparent.
  const keyed = document.createElement("canvas");
  img.onload = () => {
    keyed.width = img.naturalWidth; keyed.height = img.naturalHeight;
    const k = keyed.getContext("2d");
    k.drawImage(img, 0, 0);
    const data = k.getImageData(0, 0, keyed.width, keyed.height);
    const px = data.data;
    const W = keyed.width, H = keyed.height;
    const lum = (j) => (px[j * 4] + px[j * 4 + 1] + px[j * 4 + 2]) / 3;
    // Remplissage depuis les bords : seul le fond est retiré, pas l'imprimé blanc.
    const seen = new Uint8Array(W * H);
    const stack = [];
    for (let x = 0; x < W; x++) stack.push(x, x + (H - 1) * W);
    for (let y = 0; y < H; y++) stack.push(y * W, y * W + W - 1);
    while (stack.length) {
      const j = stack.pop();
      if (seen[j]) continue;
      seen[j] = 1;
      const l = lum(j);
      if (l < 200) continue;
      px[j * 4 + 3] = l >= 240 ? 0 : Math.round((240 - l) / 40 * 255);
      const x = j % W;
      if (x > 0) stack.push(j - 1);
      if (x < W - 1) stack.push(j + 1);
      if (j >= W) stack.push(j - W);
      if (j < W * (H - 1)) stack.push(j + W);
    }
    k.putImageData(data, 0, 0);
    ready = true;
    resize();
  };
  // Photo servie par le CDN Shopify : CORS nécessaire pour le détourage.
  img.crossOrigin = "anonymous";
  img.src = cfg.dropImage;

  function resize() {
    const r = canvas.getBoundingClientRect();
    canvas.width = Math.round(r.width * devicePixelRatio);
    canvas.height = Math.round(r.height * devicePixelRatio);
    draw(block);
  }
  addEventListener("resize", resize);

  function draw(size) {
    if (!ready) return;
    const w = canvas.width, h = canvas.height;
    ctx.clearRect(0, 0, w, h);
    if (size <= 1) {
      ctx.imageSmoothingEnabled = true;
      ctx.drawImage(keyed, 0, 0, w, h);
      return;
    }
    const sw = Math.max(2, Math.round(w / (size * devicePixelRatio)));
    const sh = Math.max(2, Math.round(h / (size * devicePixelRatio)));
    off.width = sw; off.height = sh;
    octx.filter = "grayscale(1) contrast(1.2)";
    octx.clearRect(0, 0, sw, sh);
    if (cfg.cryptoFx) {
      // Cryptage vivant : la grille glisse d'une fraction de case et chaque case scintille.
      const j = () => (Math.random() - 0.5) * 0.6;
      octx.drawImage(keyed, j(), j(), sw, sh);
      const id = octx.getImageData(0, 0, sw, sh), q = id.data;
      for (let i = 0; i < q.length; i += 4) {
        if (!q[i + 3]) continue;
        const n = Math.random() < 0.05 ? 50 + Math.random() * 60 : (Math.random() - 0.5) * 40;
        q[i] = q[i + 1] = q[i + 2] = Math.max(0, Math.min(255, q[i] + n));
      }
      octx.putImageData(id, 0, 0);
    } else {
      octx.drawImage(keyed, 0, 0, sw, sh);
    }
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(off, 0, 0, w, h);
  }

  // Survol (ou doigt appuyé) : la pixellisation se dissout et on voit la pièce.
  const piece = $(".piece");
  let peeking = false;
  let anim = null;
  function animateTo(target) {
    cancelAnimationFrame(anim);
    const from = current;
    const t0 = performance.now();
    const step = (t) => {
      const k = Math.min(1, (t - t0) / 450);
      const e = 1 - Math.pow(1 - k, 3);
      current = from + (target - from) * e;
      draw(Math.max(1, Math.round(current)));
      if (k < 1) anim = requestAnimationFrame(step);
    };
    anim = requestAnimationFrame(step);
  }
  let current = block;
  function peek(on) {
    if (peeking === on || block <= 1) return;
    peeking = on;
    document.body.classList.toggle("peek", on);
    animateTo(on ? 1 : block);
  }
  piece.addEventListener("pointerenter", (e) => e.pointerType === "mouse" && peek(true));
  piece.addEventListener("pointerleave", (e) => e.pointerType === "mouse" && peek(false));
  piece.addEventListener("contextmenu", (e) => e.preventDefault());

  // Curseur sablier : suit la souris tant qu'elle est sur la pièce.
  const hourglass = $(".hourglass");
  piece.addEventListener("pointermove", (e) => {
    if (e.pointerType !== "mouse") return;
    hourglass.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    document.body.classList.add("hg-on");
  });
  piece.addEventListener("pointerleave", () => document.body.classList.remove("hg-on"));
  piece.addEventListener("touchstart", () => peek(true), { passive: true });
  addEventListener("touchend", () => peek(false));
  addEventListener("touchcancel", () => peek(false));

  // Cryptage vivant : la pièce est redessinée en continu (scintillement + glitchs fréquents).
  if (cfg.cryptoFx) {
    // Cases assez fines pour qu'on devine une forme (au moins ~12 cases de large), taille qui respire.
    const fxSize = () => Math.min(current, canvas.getBoundingClientRect().width / 12) * (0.8 + Math.random() * 0.45);
    let pulsing = false;
    setInterval(() => { if (!peeking && !pulsing && block > 1) draw(fxSize()); }, 280);
    // Option : entre deux phases de scintillement, la pièce se montre en clair un court instant.
    if (cfg.revealPulse) {
      setInterval(() => {
        if (peeking || block <= 1) return;
        pulsing = true;
        animateTo(1);
        setTimeout(() => { if (!peeking) animateTo(block); }, 1200);
        setTimeout(() => { pulsing = false; }, 1650);
      }, 4000);
    }
    setInterval(() => {
      if (block <= 1 || peeking || pulsing || Math.random() < 0.4) return;
      const b = fxSize();
      const steps = [b * 0.5, b * 1.6, b * 0.7, b];
      let i = 0;
      const t = setInterval(() => { draw(steps[i++]); if (i >= steps.length) clearInterval(t); }, 90);
    }, 2600);
  }

  // Petit « glitch » régulier : la pièce se précise une fraction de seconde.
  setInterval(() => {
    if (block <= 1 || peeking || cfg.cryptoFx) return;
    let i = 0;
    const steps = [block * 0.6, block * 0.35, block * 0.6, block];
    const t = setInterval(() => { draw(steps[i++]); if (i >= steps.length) clearInterval(t); }, 70);
  }, 4200);

  // ---------- Compte à rebours ----------
  let live = false;
  let unlocked = false;
  let signed = false; // mode inscription : la personne est sur la liste

  function tick() {
    const diff = Math.max(0, dropTime - Date.now());
    const s = Math.floor(diff / 1000);
    setUnit("d", Math.min(99, Math.floor(s / 86400)));
    setUnit("h", Math.floor((s % 86400) / 3600));
    setUnit("m", Math.floor((s % 3600) / 60));
    setUnit("s", s % 60);

    const windowMs = cfg.revealWindowHours * 3600 * 1000;
    const reveal = Math.min(1, Math.max(0, 1 - diff / windowMs));
    const next = unlocked || diff === 0 ? 1 : Math.round(40 - reveal * 30);
    if (next !== block) { block = next; if (!peeking) { current = block; draw(block); } }

    if (diff === 0 && !live) {
      live = true;
      onLive();
    }
  }

  // ---------- Pièce : précommande / commande ----------
  const cta = $("#cta");
  let mode = null;
  let size = null;
  let variant = null;

  $("#sizes").addEventListener("click", (e) => {
    const btn = e.target.closest(".size");
    if (!btn || btn.disabled) return;
    size = btn.dataset.size;
    variant = btn.dataset.variant;
    document.querySelectorAll(".size").forEach((b) => b.setAttribute("aria-checked", b === btn));
    updateCta();
  });

  function updateCta() {
    const verb = mode === "order" ? "Commander" : "Précommander";
    cta.disabled = !size;
    cta.textContent = size ? `${verb} · ${size}` : "Choisis ta taille";
  }

  function openShop(next) {
    mode = next;
    unlocked = true;
    block = 1; current = 1; peeking = false; document.body.classList.remove("peek"); draw(1);
    document.body.classList.add("is-unlocked");
    // La pièce était masquée (écran mot de passe) : on la redessine à sa vraie taille.
    requestAnimationFrame(resize);
    $("#drawer").setAttribute("aria-hidden", "false");
    $("#drawerState").textContent = mode === "order" ? "Drop ouvert · Disponible maintenant" : "Tu es dans les temps · Précommande ouverte";
    document.body.style.setProperty("--drawer-h", `${$("#drawer").offsetHeight}px`);
    updateCta();
  }

  cta.addEventListener("click", () => {
    if (!size) return;
    // Lien panier Shopify : /cart/<variante>:1 ouvre directement le checkout.
    if (cfg.hasProduct && variant) {
      cta.disabled = true;
      cta.textContent = "Redirection…";
      location.href = `${cfg.cartUrl}/${variant}:1`;
      return;
    }
    say($("#shopMsg"), "Paiement bientôt disponible.");
  });

  // La page s'ouvre toujours cryptée : seul le code reçu par mail dévoile la pièce.

  tick();
  setInterval(tick, 1000);

  // Le jour J : en mode code tout le monde peut commander, en mode inscription seulement les inscrits.
  function onLive() {
    if (cfg.accessMode !== "signup" || signed) return openShop("order");
    const t = $("#signupTagline");
    if (t) t.textContent = "inscris-toi pour commander";
  }

  const whenText = `${fmt({ day: "2-digit", month: "2-digit" }).replace("/", ".")} à ${parseInt(fmt({ hour: "numeric", hour12: false }), 10)}h`;
  document.querySelectorAll("[data-drop-when]").forEach((el) => (el.textContent = whenText));

  if (cfg.accessMode === "signup") setupSignup(); else setupCode();

  // ---------- Rappel dans l'agenda (Apple : fichier .ics du thème, Google : lien pré-rempli) ----------
  function setupCalendar() {
    const google = $("#calGoogle");
    if (!google) return;
    const start = new Date(cfg.dropDate);
    const end = new Date(start.getTime() + 60 * 60 * 1000);
    const stamp = (d) => d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
    const title = `Drop ${cfg.dropNumber} · Dans les temps`;
    const url = location.origin + "/";
    const details = `Le drop ouvre à l'heure pile. Sois dans les temps : ${url}`;
    google.href = "https://calendar.google.com/calendar/render?" + new URLSearchParams({
      action: "TEMPLATE", text: title, dates: `${stamp(start)}/${stamp(end)}`, details, location: url,
    });
  }

  // ---------- Mode inscription (email + téléphone) ----------
  function setupSignup() {
    const KEY = "dlt_signed";
    const form = $("#mailForm");
    const msg = $("#mailMsg");
    try { signed = localStorage.getItem(KEY) === cfg.dropNumber; } catch {}
    if (form.querySelector("[data-posted]")) signed = true;
    const markSigned = () => {
      signed = true;
      try { localStorage.setItem(KEY, cfg.dropNumber); } catch {}
      if (Date.now() >= dropTime) openShop("order");
      else document.body.classList.add("is-signed");
    };
    if (signed) markSigned();
    setupCalendar();

    // Le formulaire est envoyé normalement par le navigateur (Shopify gère son anti-robot
    // puis revient sur la page avec form.posted_successfully). Tout ce qui doit partir
    // est donc préparé AVANT l'envoi, au fil de la saisie.
    const phone = $("#phone");
    const phoneOut = $("#phoneE164");
    const consent = $("#smsConsent");
    const tags = $("#signupTags");
    const btn = $("#signupBtn");
    const baseTags = tags.value;

    // 06 12 34 56 78 → +33612345678 (format attendu par Shopify)
    const normPhone = (v) => {
      let p = v.replace(/[\s.\-()]/g, "");
      if (p.startsWith("00")) p = "+" + p.slice(2);
      if (/^0\d{9}$/.test(p)) p = "+33" + p.slice(1);
      return /^\+\d{8,15}$/.test(p) ? p : null;
    };
    const syncPhone = () => {
      if (!phone) return;
      const p = normPhone(phone.value);
      phoneOut.value = p || "";
      phone.setCustomValidity(phone.value && !p ? "Numéro de téléphone invalide." : "");
    };
    // Avec le téléphone : case cochée = consentement SMS (tag lu par l'app SMS), bouton actif.
    // Sans téléphone : pas de case, l'inscription vaut abonnement email.
    const syncConsent = () => {
      if (!consent) return;
      tags.value = consent.checked ? `${baseTags},sms-ok` : baseTags;
      btn.disabled = !consent.checked;
    };
    phone?.addEventListener("input", syncPhone);
    consent?.addEventListener("change", syncConsent);
    syncPhone();
    syncConsent();

    // Déjà client : Shopify renvoie une erreur, mais la personne est bien sur la liste.
    if (form.querySelector("[data-error]")) markSigned();

    form.addEventListener("submit", (e) => {
      const block = (text) => { e.preventDefault(); e.stopImmediatePropagation(); say(msg, text); };
      syncPhone();
      syncConsent();
      if (consent && !consent.checked) return block("Coche la case pour t'inscrire.");
      if (phone && !phoneOut.value) return block("Numéro de téléphone invalide.");
      say(msg, "Envoi…");
    }, true);
  }

  // ---------- Mode code (mot de passe envoyé par mail) ----------
  function setupCode() {
    // ---------- Inscription ----------
    // Formulaire client Shopify envoyé en arrière-plan : pas de rechargement.
    // Si Shopify demande un captcha, on bascule sur l'envoi classique (page de vérification).
    const form = $("#mailForm");
    const msg = $("#mailMsg");
    const showGate = () => {
      document.body.classList.add("is-gate");
      setTimeout(() => $("#code").focus({ preventScroll: true }), 50);
    };
    // Lien du mail : /?code ouvre directement l'écran du code.
    if (form.querySelector("[data-posted]") || new URLSearchParams(location.search).has("code")) showGate();
    else if (form.querySelector("[data-error]")) say(msg, "Déjà inscrit ? Ton code est dans le mail de bienvenue.");

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const email = $("#email").value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return say(msg, "Email invalide.");
      say(msg, "Envoi…");
      try {
        const res = await fetch(form.action, { method: "POST", body: new FormData(form) });
        if (!res.ok || res.url.includes("challenge")) return form.submit();
        const html = await res.text();
        if (html.includes("data-posted")) { say(msg, ""); return showGate(); }
        // Erreur Shopify (le plus souvent : email déjà inscrit) → on propose le code.
        say(msg, "");
        showGate();
        say($("#codeMsg"), "Déjà inscrit ? Ton code est dans le mail de bienvenue.");
      } catch {
        form.submit();
      }
    });
    $("#haveCode").addEventListener("click", showGate);
    $("#backToMail").addEventListener("click", () => {
      document.body.classList.remove("is-gate");
      $("#email").focus({ preventScroll: true });
    });

    // ---------- Code d'accès ----------
    async function sha256(text) {
      const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
      return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
    }
    const codeForm = $("#codeForm");
    codeForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const codeMsg = $("#codeMsg");
      const value = $("#code").value.trim().toUpperCase();
      if (!value) return say(codeMsg, "Entre le code reçu par mail.");
      if ((await sha256(value)) !== cfg.codeHash) {
        codeForm.classList.remove("shake");
        void codeForm.offsetWidth;
        codeForm.classList.add("shake");
        return say(codeMsg, "Code incorrect.");
      }
      say(codeMsg, "");
      document.body.classList.remove("is-gate");
      openShop(Date.now() >= dropTime ? "order" : "preorder");
    });
  }
})();
